import React from "react";
import "./AboutHome.scss";
import abtExp from "../../../assets/experience.png";
// import aboutBg from "../../../assets/About/about-bg.png";
import { Link } from "react-router-dom";

const AboutHome = () => {
  let date = new Date();
  let experienceDate = new Date().getFullYear() - 1988;

  return (
    <>
      <div className="about_home">
        <div className="container">
          <div className="about_home_content">
            <h2 data-aos="fade-down">ABOUT COMPANY</h2>

            <div className="row justify-content-between">
              <div className="col-lg-6 left" data-aos="fade-right">
                <h3>
                  BETTER INSURANCE <br /> FOR EVERYONE
                </h3>
                <p>
                  {/* To make the company healthy in all respects we firmly believe
                  to exhibit absolute transparency, honesty and open
                  communication with our stake holders and clients. */}
                  With a view to catering to the growing demands of this type of
                  service Rupali Insurance Company Limited emerged as an
                  Incorporated Public Limited Company on 30th May, 1988 and
                  started it’s operations on 25th June, 1988.
                </p>
                <p>
                  As such we have the pleasure to introduce ourselves as one of
                  the leading Insurance Company of the Country in private sector
                  fully owned by Bangladeshi entrepreneurs. It has already
                  occupied a strong position amongst it's competitors and has
                  made significant contribution in the field of Insurance
                  Industry in the economy. The Chairman & Members of the Board
                  of Directors are well-reputed business personalities and
                  leading industrialists of the Country.
                </p>

                <Link className="btn main_btn mt-3" to="/company-information">
                  <span className="btn_text">Get To Know Us</span>
                </Link>
              </div>
              <div
                className="col-lg-4 my-auto position-relative right"
                data-aos="fade-left"
                data-aos-easing="ease-out-cubic"
                data-aos-duration="1000"
              >
                <img src={abtExp} className="img-fluid" alt="" />
                <div className="exp_text">
                  {experienceDate} years <br /> of Experience
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AboutHome;
